webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(326);


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(329);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(415);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(443);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _services = __webpack_require__(631);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _app = __webpack_require__(692);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(696);
	
	__webpack_require__(617);
	
	__webpack_require__(619);
	
	__webpack_require__(616);
	
	__webpack_require__(698);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _components2.default, _services2.default, 'ngMaterial']).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).component('app', _app2.default);

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _histogram = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_histogram.HistogramModule]).name;
	
	exports.default = commonModule;

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HistogramModule = undefined;
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(329);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _histogram = __webpack_require__(417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistogramModule = exports.HistogramModule = _angular2.default.module('histogram', [_angularUiRouter2.default]).component('histogram', _histogram.HistogramComponent).name;

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HistogramComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(418);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(419);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _histogram = __webpack_require__(438);
	
	var _histogram2 = _interopRequireDefault(_histogram);
	
	__webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistogramComponent = exports.HistogramComponent = {
	  bindings: {
	    onSelectDate: '&',
	    data: '<',
	    title: '@'
	  },
	  template: _histogram2.default,
	  controller: function () {
	    function HistogramController() {
	      'ngInject';
	
	      (0, _classCallCheck3.default)(this, HistogramController);
	      this.name = 'histogram';
	    }
	
	    (0, _createClass3.default)(HistogramController, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.options = this.getHistogramOptions(this.title);
	        this.fn = this.selectDate.bind(this);
	      }
	
	      /*
	      * builds the option object for Chartjs
	      *
	      * @param { String } yTitle title for y axis
	      *
	      * @return { Object } graph options object
	      * */
	
	    }, {
	      key: 'getHistogramOptions',
	      value: function getHistogramOptions(yTitle) {
	        return {
	          scales: {
	            yAxes: [{
	              ticks: { beginAtZero: true },
	              scaleLabel: {
	                display: true,
	                labelString: yTitle
	              }
	            }],
	            xAxes: [{
	              scaleLabel: {
	                display: true,
	                labelString: 'Days of the month'
	              }
	            }]
	          }
	        };
	      }
	
	      /*
	      * emits a search event passign the query params
	      *
	      * */
	
	    }, {
	      key: 'selectDate',
	      value: function selectDate(event) {
	        this.onSelectDate({
	          $event: {
	            date: event[0]._model.label
	          }
	        });
	      }
	    }]);
	    return HistogramController;
	  }()
	};

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	module.exports = "<div class=\"graph\" ng-if=\"$ctrl.data\">\n  <canvas class=\"chart chart-bar\"\n          chart-data=\"[$ctrl.data.data]\"\n          chart-series=\"['flight count']\"\n          chart-labels=\"$ctrl.data.labels\"\n          chart-options=\"$ctrl.options\"\n          chart-click=\"$ctrl.fn\">\n  </canvas>\n</div>\n"

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(440);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(442)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./histogram.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./histogram.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(441)();
	// imports
	
	
	// module
	exports.push([module.id, ".graph{position:relative;width:90%;height:100%;margin:auto}", ""]);
	
	// exports


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(444);
	
	var _airportSelector = __webpack_require__(615);
	
	var _results = __webpack_require__(626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_home.HomeModule, _results.ResultsModule, _airportSelector.AirportSelectorModule]).name;
	
	exports.default = componentModule;

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeModule = undefined;
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(329);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularChart = __webpack_require__(445);
	
	var _angularChart2 = _interopRequireDefault(_angularChart);
	
	var _home = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeModule = exports.HomeModule = _angular2.default.module('home', [_angularUiRouter2.default, _angularChart2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('home', {
	    url: '/',
	    component: 'home',
	    resolve: {
	      csv: ["AirportService", function csv(AirportService) {
	        return AirportService.fetchFiles();
	      }]
	    }
	  });
	}]).component('home', _home.HomeComponent).name;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 479,
		"./af.js": 479,
		"./ar": 480,
		"./ar-dz": 481,
		"./ar-dz.js": 481,
		"./ar-kw": 482,
		"./ar-kw.js": 482,
		"./ar-ly": 483,
		"./ar-ly.js": 483,
		"./ar-ma": 484,
		"./ar-ma.js": 484,
		"./ar-sa": 485,
		"./ar-sa.js": 485,
		"./ar-tn": 486,
		"./ar-tn.js": 486,
		"./ar.js": 480,
		"./az": 487,
		"./az.js": 487,
		"./be": 488,
		"./be.js": 488,
		"./bg": 489,
		"./bg.js": 489,
		"./bm": 490,
		"./bm.js": 490,
		"./bn": 491,
		"./bn.js": 491,
		"./bo": 492,
		"./bo.js": 492,
		"./br": 493,
		"./br.js": 493,
		"./bs": 494,
		"./bs.js": 494,
		"./ca": 495,
		"./ca.js": 495,
		"./cs": 496,
		"./cs.js": 496,
		"./cv": 497,
		"./cv.js": 497,
		"./cy": 498,
		"./cy.js": 498,
		"./da": 499,
		"./da.js": 499,
		"./de": 500,
		"./de-at": 501,
		"./de-at.js": 501,
		"./de-ch": 502,
		"./de-ch.js": 502,
		"./de.js": 500,
		"./dv": 503,
		"./dv.js": 503,
		"./el": 504,
		"./el.js": 504,
		"./en-au": 505,
		"./en-au.js": 505,
		"./en-ca": 506,
		"./en-ca.js": 506,
		"./en-gb": 507,
		"./en-gb.js": 507,
		"./en-ie": 508,
		"./en-ie.js": 508,
		"./en-nz": 509,
		"./en-nz.js": 509,
		"./eo": 510,
		"./eo.js": 510,
		"./es": 511,
		"./es-do": 512,
		"./es-do.js": 512,
		"./es-us": 513,
		"./es-us.js": 513,
		"./es.js": 511,
		"./et": 514,
		"./et.js": 514,
		"./eu": 515,
		"./eu.js": 515,
		"./fa": 516,
		"./fa.js": 516,
		"./fi": 517,
		"./fi.js": 517,
		"./fo": 518,
		"./fo.js": 518,
		"./fr": 519,
		"./fr-ca": 520,
		"./fr-ca.js": 520,
		"./fr-ch": 521,
		"./fr-ch.js": 521,
		"./fr.js": 519,
		"./fy": 522,
		"./fy.js": 522,
		"./gd": 523,
		"./gd.js": 523,
		"./gl": 524,
		"./gl.js": 524,
		"./gom-latn": 525,
		"./gom-latn.js": 525,
		"./gu": 526,
		"./gu.js": 526,
		"./he": 527,
		"./he.js": 527,
		"./hi": 528,
		"./hi.js": 528,
		"./hr": 529,
		"./hr.js": 529,
		"./hu": 530,
		"./hu.js": 530,
		"./hy-am": 531,
		"./hy-am.js": 531,
		"./id": 532,
		"./id.js": 532,
		"./is": 533,
		"./is.js": 533,
		"./it": 534,
		"./it.js": 534,
		"./ja": 535,
		"./ja.js": 535,
		"./jv": 536,
		"./jv.js": 536,
		"./ka": 537,
		"./ka.js": 537,
		"./kk": 538,
		"./kk.js": 538,
		"./km": 539,
		"./km.js": 539,
		"./kn": 540,
		"./kn.js": 540,
		"./ko": 541,
		"./ko.js": 541,
		"./ky": 542,
		"./ky.js": 542,
		"./lb": 543,
		"./lb.js": 543,
		"./lo": 544,
		"./lo.js": 544,
		"./lt": 545,
		"./lt.js": 545,
		"./lv": 546,
		"./lv.js": 546,
		"./me": 547,
		"./me.js": 547,
		"./mi": 548,
		"./mi.js": 548,
		"./mk": 549,
		"./mk.js": 549,
		"./ml": 550,
		"./ml.js": 550,
		"./mr": 551,
		"./mr.js": 551,
		"./ms": 552,
		"./ms-my": 553,
		"./ms-my.js": 553,
		"./ms.js": 552,
		"./my": 554,
		"./my.js": 554,
		"./nb": 555,
		"./nb.js": 555,
		"./ne": 556,
		"./ne.js": 556,
		"./nl": 557,
		"./nl-be": 558,
		"./nl-be.js": 558,
		"./nl.js": 557,
		"./nn": 559,
		"./nn.js": 559,
		"./pa-in": 560,
		"./pa-in.js": 560,
		"./pl": 561,
		"./pl.js": 561,
		"./pt": 562,
		"./pt-br": 563,
		"./pt-br.js": 563,
		"./pt.js": 562,
		"./ro": 564,
		"./ro.js": 564,
		"./ru": 565,
		"./ru.js": 565,
		"./sd": 566,
		"./sd.js": 566,
		"./se": 567,
		"./se.js": 567,
		"./si": 568,
		"./si.js": 568,
		"./sk": 569,
		"./sk.js": 569,
		"./sl": 570,
		"./sl.js": 570,
		"./sq": 571,
		"./sq.js": 571,
		"./sr": 572,
		"./sr-cyrl": 573,
		"./sr-cyrl.js": 573,
		"./sr.js": 572,
		"./ss": 574,
		"./ss.js": 574,
		"./sv": 575,
		"./sv.js": 575,
		"./sw": 576,
		"./sw.js": 576,
		"./ta": 577,
		"./ta.js": 577,
		"./te": 578,
		"./te.js": 578,
		"./tet": 579,
		"./tet.js": 579,
		"./th": 580,
		"./th.js": 580,
		"./tl-ph": 581,
		"./tl-ph.js": 581,
		"./tlh": 582,
		"./tlh.js": 582,
		"./tr": 583,
		"./tr.js": 583,
		"./tzl": 584,
		"./tzl.js": 584,
		"./tzm": 585,
		"./tzm-latn": 586,
		"./tzm-latn.js": 586,
		"./tzm.js": 585,
		"./uk": 587,
		"./uk.js": 587,
		"./ur": 588,
		"./ur.js": 588,
		"./uz": 589,
		"./uz-latn": 590,
		"./uz-latn.js": 590,
		"./uz.js": 589,
		"./vi": 591,
		"./vi.js": 591,
		"./x-pseudo": 592,
		"./x-pseudo.js": 592,
		"./yo": 593,
		"./yo.js": 593,
		"./zh-cn": 594,
		"./zh-cn.js": 594,
		"./zh-hk": 595,
		"./zh-hk.js": 595,
		"./zh-tw": 596,
		"./zh-tw.js": 596
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 478;


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(418);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(419);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _home = __webpack_require__(611);
	
	var _home2 = _interopRequireDefault(_home);
	
	__webpack_require__(612);
	
	var _airport = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeComponent = exports.HomeComponent = {
	  bindings: {},
	  template: _home2.default,
	  controller: function () {
	    SearchCardController.$inject = ["$state"];
	    function SearchCardController($state) {
	      'ngInject';
	
	      (0, _classCallCheck3.default)(this, SearchCardController);
	      this.name = 'Home';
	      this.$state = $state;
	    }
	
	    /*
	    * Fetch the data for both histograms and the overall Ratio
	    *
	    * @param { Object } query containing origin and destination
	    * */
	
	
	    (0, _createClass3.default)(SearchCardController, [{
	      key: 'searchData',
	      value: function searchData(query) {
	        this.$state.go('results', { origin: query.origin, destination: query.destination });
	      }
	    }]);
	    return SearchCardController;
	  }()
	};

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

	module.exports = "<div class=\"content\">\n  <airport-selector\n    on-search=\"$ctrl.searchData($event)\">\n  </airport-selector>\n</div>\n"

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(613);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(442)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(441)();
	// imports
	
	
	// module
	exports.push([module.id, "home .content{display:flex;flex-direction:column;align-items:center;width:100%;height:100%}", ""]);
	
	// exports


/***/ }),

/***/ 614:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GRAPH_TYPE = exports.GRAPH_TYPE = {
	  DELAY: 'ARR_DELAY_BIN',
	  DELAY_RATIO: 'DELAY_RATIO_BIN'
	};
	
	var AIRPORT_TYPE = exports.AIRPORT_TYPE = {
	  ORIGIN: {
	    from: 'ORIGIN',
	    to: 'DEST'
	  },
	  DEST: {
	    from: 'DEST',
	    to: 'ORIGIN'
	  }
	};

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AirportSelectorModule = undefined;
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(329);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	__webpack_require__(616);
	
	var _airportSelector = __webpack_require__(622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AirportSelectorModule = exports.AirportSelectorModule = _angular2.default.module('airportSelector', [_angularUiRouter2.default]).component('airportSelector', _airportSelector.AirportSelectorComponent).name;

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AirportSelectorComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(418);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(419);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _airport = __webpack_require__(614);
	
	var _airportSelector = __webpack_require__(623);
	
	var _airportSelector2 = _interopRequireDefault(_airportSelector);
	
	__webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AirportSelectorComponent = exports.AirportSelectorComponent = {
	  bindings: {
	    onSearch: '&'
	  },
	  template: _airportSelector2.default,
	  controller: function () {
	    AirportSelectorController.$inject = ["AirportService"];
	    function AirportSelectorController(AirportService) {
	      'ngInject';
	
	      (0, _classCallCheck3.default)(this, AirportSelectorController);
	      this.originAirport = '';
	      this.destinationAirport = '';
	      this.airService = AirportService;
	
	      this.allOrigins = this.airService.getAirports(_airport.AIRPORT_TYPE.ORIGIN);
	      this.allDestinations = this.airService.getAirports(_airport.AIRPORT_TYPE.DEST);
	    }
	
	    /*
	    * emits a search event passing the query params
	    *
	    * */
	
	
	    (0, _createClass3.default)(AirportSelectorController, [{
	      key: 'search',
	      value: function search() {
	        this.onSearch({
	          $event: {
	            origin: this.originAirport,
	            destination: this.destinationAirport
	          }
	        });
	      }
	
	      /*
	      * fetch airports options for origin selected
	      *
	      * */
	
	    }, {
	      key: 'fetchOrigin',
	      value: function fetchOrigin() {
	        this.possibleOrigins = this.airService.getAirports(_airport.AIRPORT_TYPE.ORIGIN, this.destinationAirport);
	      }
	
	      /*
	      * fetch airports options for destination selected
	      *
	      * */
	
	    }, {
	      key: 'fetchDestination',
	      value: function fetchDestination() {
	        this.possibleDestinations = this.airService.getAirports(_airport.AIRPORT_TYPE.DEST, this.originAirport);
	      }
	    }]);
	    return AirportSelectorController;
	  }()
	};

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

	module.exports = "<div class=\"nav-area\">\n  <md-input-container>\n    <label>Origin</label>\n    <md-select ng-model=\"$ctrl.originAirport\" ng-change=\"$ctrl.fetchDestination()\">\n      <md-option ng-value=\"\"><em>None</em></md-option>\n      <md-option ng-repeat=\"airport in ($ctrl.possibleOrigins || $ctrl.allOrigins)\" ng-value=\"airport.code\">\n        {{airport.name}}\n      </md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container>\n    <label>Destination</label>\n    <md-select ng-model=\"$ctrl.destinationAirport\" ng-change=\"$ctrl.fetchOrigin()\">\n      <md-option ng-value=\"\"><em>None</em></md-option>\n      <md-option ng-repeat=\"airport in ($ctrl.possibleDestinations || $ctrl.allDestinations)\" ng-value=\"airport.code\">\n        {{airport.name}}\n      </md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-button class=\"md-raised md-primary\"\n             ng-click=\"$ctrl.search()\"\n             ng-disabled=\"!$ctrl.originAirport || !$ctrl.destinationAirport\"\n  >\n    Go!\n  </md-button>\n</div>\n"

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(442)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./airportSelector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./airportSelector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(441)();
	// imports
	
	
	// module
	exports.push([module.id, ".nav-area{display:flex;width:90vw;max-width:600px;height:60px;justify-content:space-around;margin:0 auto 30px}.nav-area md-input-container{width:200px}", ""]);
	
	// exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResultsModule = undefined;
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(329);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _results = __webpack_require__(627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultsModule = exports.ResultsModule = _angular2.default.module('results', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('results', {
	    url: '/results/:origin/:destination',
	    component: 'results',
	    resolve: {
	      csv: ["AirportService", function csv(AirportService) {
	        return AirportService.fetchFiles();
	      }]
	    }
	  });
	}]).component('results', _results.ResultsComponent).name;

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ResultsComponent = undefined;
	
	var _classCallCheck2 = __webpack_require__(418);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(419);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _results = __webpack_require__(628);
	
	var _results2 = _interopRequireDefault(_results);
	
	__webpack_require__(629);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultsComponent = exports.ResultsComponent = {
	  bindings: {},
	  template: _results2.default,
	  controller: function () {
	    ResultsController.$inject = ["AirportService", "$stateParams", "$scope", "$state"];
	    function ResultsController(AirportService, $stateParams, $scope, $state) {
	      'ngInject';
	
	      (0, _classCallCheck3.default)(this, ResultsController);
	      this.byDay = false;
	      this.$scope = $scope;
	      this.$state = $state;
	      this.airService = AirportService;
	      this.origin = $stateParams['origin'];
	      this.destination = $stateParams['destination'];
	      this.byDay = false;
	    }
	
	    (0, _createClass3.default)(ResultsController, [{
	      key: '$onInit',
	      value: function $onInit() {
	        this.delayType = 'Minutes';
	        this.bestDay = this.airService.getBestDayAndTime(this.origin, this.destination);
	        this.flights = this.airService.getGraphData(this.origin, this.destination, 'ARR_DELAY');
	        this.flightsRatio = this.airService.getGraphData(this.origin, this.destination, 'DELAY_RATIO');
	        this.overallRatio = this.airService.getOverallRatio(this.origin, this.destination);
	      }
	    }, {
	      key: 'selectDate',
	      value: function selectDate(event) {
	        this.flightsByDay = this.airService.getGraphDataByDay(this.origin, this.destination, 'ARR_DELAY', event.date);
	        this.flightsByDayRatio = this.airService.getGraphDataByDay(this.origin, this.destination, 'DELAY_RATIO', event.date);
	        this.byDay = true;
	        this.$scope.$apply();
	      }
	    }, {
	      key: 'back',
	      value: function back() {
	        if (this.byDay) {
	          this.byDay = false;
	        } else {
	          this.$state.go('home');
	        }
	      }
	    }]);
	    return ResultsController;
	  }()
	};

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"header\">\n    <h2 class=\"primary\">{{($ctrl.bestDay.day | date)}} at {{$ctrl.bestDay.time}}</h2>\n    <p ng-if=\"$ctrl.bestDay\">this is the best date and time</p>\n  </div>\n  <div class=\"graphs\">\n    <div class=\"graph-header\">\n      <md-button  ng-click=\"$ctrl.back()\">\n        <md-icon>arrow_back</md-icon>\n        back\n      </md-button>\n      <p ng-if=\"$ctrl.overallRatio\">Overall Delay: {{($ctrl.overallRatio | number:2)}}%</p>\n      <md-switch ng-model=\"$ctrl.delayType\" class=\"md-primary\" ng-false-value=\"'Minutes'\" ng-true-value=\"'Ratio (%)'\">\n        Delay in {{ $ctrl.delayType }}\n      </md-switch>\n    </div>\n    <div ng-if=\"!$ctrl.byDay\">\n      <histogram data=\"$ctrl.flights\"\n                 title=\"Delay (mins)\"\n                 on-select-date=\"$ctrl.selectDate($event)\"\n                 ng-if=\"$ctrl.delayType == 'Minutes'\"></histogram>\n\n      <histogram data=\"$ctrl.flightsRatio\"\n                 title=\"Delay Ratio (%)\"\n                 on-select-date=\"$ctrl.selectDate($event)\"\n                 ng-if=\"$ctrl.delayType == 'Ratio (%)'\"></histogram>\n      </div>\n\n   <div ng-if=\"$ctrl.byDay\">\n     <histogram data=\"$ctrl.flightsByDay\"\n                  title=\"Delay (min)\"\n                  ng-if=\"$ctrl.delayType == 'Minutes'\"></histogram>\n\n     <histogram data=\"$ctrl.flightsByDayRatio\"\n                title=\"Delay Ratio (%)\"\n                ng-if=\"$ctrl.delayType == 'Ratio (%)'\"></histogram>\n   </div>\n  </div>\n</div>\n"

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(630);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(442)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./results.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./results.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(441)();
	// imports
	
	
	// module
	exports.push([module.id, "results .header{height:10vh;text-align:center}results .graphs{height:50vh}results .graphs .graph-header{display:flex;justify-content:space-between;align-items:center}results h2{color:#3f51b5;font-size:2em;margin-bottom:-10px}", ""]);
	
	// exports


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _airport = __webpack_require__(632);
	
	var _airport2 = _interopRequireDefault(_airport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesModule = _angular2.default.module('app.services', [_airport2.default]).name;
	
	exports.default = ServicesModule;

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(327);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _airport = __webpack_require__(633);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AirportModule = _angular2.default.module('airportModule', []).service('AirportService', _airport.AirportService).name;
	
	exports.default = AirportModule;

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AirportService = undefined;
	
	var _extends2 = __webpack_require__(634);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toArray2 = __webpack_require__(657);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _slicedToArray2 = __webpack_require__(680);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(418);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(419);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(691);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _moment = __webpack_require__(476);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AirportService = exports.AirportService = function () {
	  AirportService.$inject = ["$http", "$q"];
	  function AirportService($http, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AirportService);
	    this.initial = {
	      'data': [],
	      'labels': []
	    };
	    this.$http = $http;
	    this.$q = $q;
	  }
	
	  /*
	  * This method fetch:
	  * - FlightDelays.csv: flight data from CA airports
	  * - airports-usa.json: airport codes and names
	  * This method also prepares these data to be used
	  * @return { Promise } promise to be resolved once files are fetched and parsed
	  * */
	
	
	  (0, _createClass3.default)(AirportService, [{
	    key: 'fetchFiles',
	    value: function fetchFiles() {
	      var _this = this;
	
	      console.log('fetch called');
	      console.time('fetch files');
	      if (this.parsedData && this.airports) {
	        return this.$q.resolve();
	      }
	      return this.$q.all([this.$http.get('assets/FlightDelays.csv'), this.$http.get('assets/airports-usa.json')]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            flightCsv = _ref2[0],
	            airportsJson = _ref2[1];
	
	        console.timeEnd('fetch files');
	        console.time('parse csv');
	        _this.parsedData = _this.parseCsv2Json(flightCsv.data);
	        console.timeEnd('parse csv');
	        console.time('parse json');
	        _this.airports = _this.parseAirportJson(airportsJson.data);
	        console.timeEnd('parse json');
	      });
	    }
	
	    /*
	    * Parses the csv into json
	    *
	    * @param { String } csv string in csv format with flights data
	    * @return { Array } flights data
	    * */
	
	  }, {
	    key: 'parseCsv2Json',
	    value: function parseCsv2Json(csv) {
	      //parse into header and rows using deconstruct
	      var _csv$split = csv.split('\n'),
	          _csv$split2 = (0, _toArray3.default)(_csv$split),
	          headers = _csv$split2[0],
	          rows = _csv$split2.slice(1);
	
	      headers = headers.split(',');
	
	      console.time('parse csv');
	      //build and return a json object
	      return rows.map(function (row) {
	        return row.split(',').reduce(function (map, val, i) {
	          map[headers[i]] = val;
	          return map;
	        }, {});
	      });
	    }
	
	    /*
	    * Picks into json to retrieve only:
	    * - iata: airport code
	    * - name: airport name
	    *
	    * @param { Array } json array of all airports data
	    * @return { Array } reduced json
	    * */
	
	  }, {
	    key: 'parseAirportJson',
	    value: function parseAirportJson(json) {
	      return json.map(function (airport) {
	        return {
	          'code': airport.iata,
	          'name': airport.name
	        };
	      });
	    }
	
	    /*
	    * Retrieves the airports based on origin or destination
	    * if airport is omitted returns all airports
	    *
	    * @param { Object } type selector for origin or destination
	    * @param { String } airport code to airport (origin or destination)
	    * @return { Array } airports listing
	    * */
	
	  }, {
	    key: 'getAirports',
	    value: function getAirports(type, airport) {
	      var _this2 = this;
	
	      var froms = this.parsedData.filter(function (flight) {
	        if (airport) {
	          return flight[type.from] == airport;
	        }
	        return true;
	      }).map(function (flight) {
	        return flight[type.to];
	      });
	
	      return _.chain(froms).uniq().map(function (airCode) {
	        return _.find(_this2.airports, function (air) {
	          return air.code == airCode;
	        });
	      }).sortBy('name').value();
	    }
	
	    /*
	    * Builds the graph data
	    *
	    * @param { String } origin code for origin airport
	    * @param { String } dest code for destination airport
	    * @param { Object } group selector between DELAY or DELAY RATIO
	    * @return { Array } returns two data arrays data and labels
	    * */
	
	  }, {
	    key: 'getHistogramData',
	    value: function getHistogramData(origin, dest, group) {
	      return _.chain(this.parsedData)
	      // selects only late arrivals
	      .filter(function (flight) {
	        return flight.ARR_DELAY > 0;
	      }).filter({ 'ORIGIN': origin, 'DEST': dest }).map(this.calcAdditionalParams.bind(this)).groupBy(group)
	      // sorts by Arrival Delay
	      .reduce(function (acc, value, key) {
	        acc.push({ 'value': value.length, 'group': +key });
	        return acc;
	      }, []).sortBy('group')
	      // builds the series for histogram
	      .reduce(function (acc, item) {
	        acc.data.push(item.value);
	        acc.labels.push(item.group + ' - ' + (item.group + 10));
	        return acc;
	      }, _.cloneDeep(this.initial)).value();
	    }
	  }, {
	    key: 'getGraphDataByDay',
	    value: function getGraphDataByDay(origin, dest, group, date) {
	      return _.chain(this.parsedData).filter({ 'ORIGIN': origin, 'DEST': dest, 'FL_DATE': date }).map(this.calcAdditionalParams.bind(this)).groupBy('CRS_DEP_TIME_INT').map(function (flights, date) {
	        var delay = flights.reduce(function (acc, flight) {
	          return acc + parseFloat(flight[group]);
	        }, 0) / flights.length;
	        return { date: date, delay: delay, flights: flights };
	      }).reduce(function (acc, item) {
	        acc.data.push(item.delay);
	        acc.labels.push(item.date);
	        return acc;
	      }, _.cloneDeep(this.initial)).value();
	    }
	
	    /*
	    * Builds the graph data
	    *
	    * @param { String } origin code for origin airport
	    * @param { String } dest code for destination airport
	    * @param { Object } group selector between DELAY or DELAY RATIO
	    * @return { Array } returns two data arrays data and labels
	    * */
	
	  }, {
	    key: 'getGraphData',
	    value: function getGraphData(origin, dest, group) {
	      return _.chain(this.parsedData).filter({ 'ORIGIN': origin, 'DEST': dest }).map(this.calcAdditionalParams.bind(this)).groupBy('FL_DATE').map(function (flights, date) {
	        var delay = flights.reduce(function (acc, flight) {
	          return acc + parseFloat(flight[group]);
	        }, 0) / flights.length;
	        return { date: date, delay: delay, flights: flights };
	      }).reduce(function (acc, item) {
	        acc.data.push(item.delay);
	        acc.labels.push(item.date);
	        return acc;
	      }, _.cloneDeep(this.initial)).value();
	    }
	
	    /*
	    * Calculates the overall ratio (delay/elapsed time)
	    * for desired airports
	    *
	    * @param { String } origin code for origin airport
	    * @param { String } dest code for destination airport
	    * @return { Array } overall ratio (%)
	    * */
	
	  }, {
	    key: 'getOverallRatio',
	    value: function getOverallRatio(origin, dest) {
	      var length = void 0;
	      var sum = _.chain(this.parsedData).filter({ 'ORIGIN': origin, 'DEST': dest }).map(this.calcAdditionalParams.bind(this)).tap(function (set) {
	        return length = set.length;
	      }).reduce(function (acc, item) {
	        return acc + item.DELAY_RATIO;
	      }, 0).value();
	
	      return sum / length;
	    }
	
	    /*
	    * Calculates the overall ratio (delay/elapsed time)
	    * for desired airports
	    *
	    * @param { String } origin code for origin airport
	    * @param { String } dest code for destination airport
	    * @return { Array } overall ratio (%)
	    * */
	
	  }, {
	    key: 'getBestDayAndTime',
	    value: function getBestDayAndTime(origin, dest) {
	      var flights = _.chain(this.parsedData).filter({ 'ORIGIN': origin, 'DEST': dest }).map(this.calcAdditionalParams.bind(this)).groupBy('FL_DATE').map(function (flights, date) {
	        var delay = flights.reduce(function (acc, flight) {
	          return acc + flight.ARR_DELAY;
	        }, 0) / flights.length;
	        return { date: date, delay: delay, flights: flights };
	      }).value();
	
	      var bestDay = _.minBy(flights, 'delay');
	      var bestTime = _.minBy(bestDay.flights, 'ARR_DELAY');
	      return { day: bestDay.date, time: bestTime.CRS_DEP_TIME_INT };
	    }
	
	    // utility functions //
	
	    /*
	    * Utility functions to Round time in half hours
	    *
	    * @param { String } time time of departure
	    * @return { String } rounded time
	    * */
	
	  }, {
	    key: 'roundTime',
	    value: function roundTime(time) {
	      var hour = time.slice(0, 2);
	      var min = time.slice(2, 4);
	      hour = (parseInt(hour) + Math.round(parseInt(min) / 60)) % 24;
	      min = Math.round(parseInt(min) / 30) * 30 % 60;
	      min = min < 10 ? '0' + min : '' + min;
	      return hour + ':' + min;
	    }
	
	    /*
	    * Utility functions to calculate additional parameters
	    * to be used in graph plotting
	    *
	    * @param { Array } flight flights data
	    * @return { Array } reduced flights data
	    * */
	
	  }, {
	    key: 'calcAdditionalParams',
	    value: function calcAdditionalParams(flight) {
	      var ratio = flight.ARR_DELAY / flight.CRS_ELAPSED_TIME * 100;
	      return (0, _extends3.default)({}, flight, {
	        'ARR_DELAY': flight.ARR_DELAY == '' ? 0 : parseFloat(flight.ARR_DELAY),
	        'WEEK_DAY': (0, _moment2.default)(flight.FL_DATE, 'YYYY-MM-DD').format('ddd'),
	        'CRS_DEP_TIME_INT': this.roundTime(flight.CRS_DEP_TIME + ''),
	        'ARR_DELAY_BIN': Math.floor(flight.ARR_DELAY / 10) * 10,
	        'DELAY_RATIO': ratio,
	        'DELAY_RATIO_BIN': Math.floor(ratio / 10) * 10
	
	      });
	    }
	  }]);
	  return AirportService;
	}();

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(693);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(694);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div class=\"title\">\n    <h1>Flight Statistics</h1>\n  </div>\n  <div ui-view></div>\n</div>\n"

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(695);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(442)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(441)();
	// imports
	exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100vh;font:62.5% Roboto,sans-serif}*{box-sizing:border-box;font-size:14px;font-family:Roboto,sans-serif}.app{height:100vh;background-color:#f1f1f1;display:flex;flex-direction:column;justify-content:center;align-items:center}.title{height:10vh;transition:all .5s linear}.title h1{font-weight:bolder;color:#888;letter-spacing:2px}h2{text-align:center}.container{width:90vw;height:70vh}", ""]);
	
	// exports


/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js